import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { SignupTemplate } from "components/entrance/signup";
import useKakaoChannel from "hooks/useKakaoChannel";
const passUrl = process.env.REACT_APP_PASS_URL;

// verifyCode
// AVAILABLE : 가입 가능
// DUPLICATE : 이미 가입된 번호
// LIMIT : 가입 가능한 인원제한 초과
// NOT_FOUND : CRM 에서 해당 번호 찾을 수 없음
// WITHDRAWAL : 계정 탈퇴를 한 회원

const SignupConfirm = () => {
  const location = useLocation();
  const { verifyCode } = location.state;
  const { phoneNumber, useTermYN, privacyYN, marketingYN } = useSelector(
    (state) => state.signup
  );
  const { handleClickOpenKakao } = useKakaoChannel();

  const navigate = useNavigate();
  const NAMING_OBJECT = {
    AVAILABLE: {
      title: "가입가능한 휴대폰 번호입니다\n본인인증을 진행해주세요",
      buttonText: "본인인증",
      buttonColor: "primary100",
      border: "primary100",
      buttonOnClick: () => {
        window.localStorage.setItem(
          "signUpBasicInfo",
          JSON.stringify({
            phoneNumber,
            useTermYN,
            privacyYN,
            marketingYN,
          })
        );
        window.location = passUrl;
      },
      infoTitle: false,
      infoText: false,
    },
    DUPLICATE: {
      title: "이미 가입되어 있는\n휴대폰 번호입니다",
      buttonText: "로그인하기",
      buttonColor: "primary100",
      border: "primary100",
      buttonOnClick: () => navigate("/entrance/signin"),
      infoTitle: false,
      infoText: false,
    },
    LIMIT: {
      title: "관리자 등록 가능 계정 수가\n초과되었습니다",
      buttonText: "바디코디에 문의하기",
      buttonColor: "white",
      border: "line30",
      buttonOnClick: handleClickOpenKakao,
      infoTitle: "관리자 등록 가능 계정 수를 확인해주세요",
      infoText:
        "관리자앱은 바디코디 회원관리 프로그램에 관리자로 등록된 분만 이용하실 수 있습니다. 바디코디가 처음이거나 관리자 앱 이용을 원하시는 분들은 바디코디로 문의해주세요.",
    },
    NOT_FOUND: {
      title: "관리자로 등록되어 있지 않은\n휴대폰 번호입니다",
      buttonText: "바디코디에 문의하기",
      buttonColor: "white",
      border: "line30",
      buttonOnClick: handleClickOpenKakao,
      infoTitle: "바디코디 관리자 앱을 사용하시려면?",
      infoText:
        "관리자 앱에 등록 가능한 관리자 계정 수는 라이트 버전의 경우 1명, 프로이상의 버전은 3명으로 제한됩니다. 궁금하신 점은 바디코디에 문의해주세요.",
    },
    WITHDRAWAL: {
      title: "관리자 계정을 탈퇴한\n휴대폰 번호입니다",
      buttonText: "바디코디에 문의하기",
      buttonColor: "white",
      border: "line30",
      buttonOnClick: handleClickOpenKakao,
      infoTitle: "바디코디 관리자 앱을 재가입하시려면?",
      infoText:
        "탈퇴한 계정은 당일 재가입이 불가하며, 재가입이 필요한 경우 탈퇴일 00시 기준으로 재가입 가능합니다. 자세한 사항은 바디코디에 문의해주세요.",
    },
    EMPTY_CRM_TYPE: {
      title: "관리자로 등록되어 있지 않은\n휴대폰 번호입니다",
      buttonText: "바디코디에 문의하기",
      buttonColor: "white",
      border: "line30",
      buttonOnClick: handleClickOpenKakao,
      infoTitle: "바디코디 관리자 앱을 사용하시려면?",
      infoText:
        "관리자 앱에 등록 가능한 관리자 계정 수는 라이트 버전의 경우 1명, 프로이상의 버전은 3명으로 제한됩니다. 궁금하신 점은 바디코디에 문의해주세요.",
    },
  };

  const {
    title,
    buttonText,
    buttonColor,
    border,
    buttonOnClick,
    infoTitle,
    infoText,
  } = NAMING_OBJECT[verifyCode];

  return (
    <SignupTemplate
      title={title}
      inputLabel="아이디"
      inputValue={phoneNumber}
      inputValueChange={() => {}}
      inputIsDisabled={true}
      buttonText={buttonText}
      border={border}
      buttonColor={buttonColor}
      buttonOnClick={buttonOnClick}
      infoTitle={infoTitle}
      infoText={infoText}
    />
  );
};
export default SignupConfirm;
